export default __webpack_public_path__ + "static/media/Custom-HUD-Pop-Up (1 Layer, 3D).95807667.jpg";